import { AnimateOnScroll } from "../../../components/animate";
import { AnimateWordsOnScroll } from "../../../components/animate/animateWords";
import { FaqAccordion } from "../../../components/accordion/faqAccordion";
import { faqItems } from "../data/landingContent";

export const FaqSection = () => {
  return (
    <section id="faqs" className="max-width-website py-12 md:py-16">
      <div className="flex flex-col gap-10 lg:flex-row lg:gap-16">
        <div className="flex flex-col gap-3 lg:w-[400px] lg:shrink-0">
          <AnimateWordsOnScroll
            as="h2"
            className="font-dela text-[32px] leading-[1.1] text-ink md:text-[44px]"
          >
            Frequently asked questions
          </AnimateWordsOnScroll>
          <AnimateOnScroll animation="blur-up" delay={0.4}>
            <p className="font-onest text-lg tracking-[-0.4px] text-[#4f4e4e]">
              Got more questions? Send them to us{" "}
              <a
                href="mailto:hello@usetikket.com"
                className="underline hover:text-ink"
              >
                hello@usetikket.com
              </a>
            </p>
          </AnimateOnScroll>
        </div>

        <AnimateOnScroll animation="fade-up" delay={0.15} className="flex-1">
          <FaqAccordion items={faqItems} />
        </AnimateOnScroll>
      </div>
    </section>
  );
};
